import GrantCard from '@hellodarwin/core/lib/components/grants/card';
import { useAppSelector } from '../../../../../../../../app/app-hooks';
import { selectAllFundingExplorerGrants } from '../../../../../../../../features/api/slices/grants-slice';
import OnboardingTalkToExpertOverlay from './components/OnboardingTalkToExpertOverlay';
import OnboardingGrantsSuggestionsWrapper from './wrapper';
import { GrantsSuggestionsContent } from './styles';

const OnboardingGrantsSuggestions = () => {
  const suggestedGrants = useAppSelector(selectAllFundingExplorerGrants);

  if (!suggestedGrants || suggestedGrants.length === 0) return null;

  return (
    <OnboardingGrantsSuggestionsWrapper>
      <OnboardingTalkToExpertOverlay>
        <GrantsSuggestionsContent>
          {suggestedGrants.map((grant) => (
            <GrantCard
              key={grant.grant_id}
              {...grant}
              cardSize="small"
              type="detail"
            />
          ))}
        </GrantsSuggestionsContent>
      </OnboardingTalkToExpertOverlay>
    </OnboardingGrantsSuggestionsWrapper>
  );
};

export default OnboardingGrantsSuggestions;
